export enum CreateDepartmentVariant {
  save = 'save',
  saveAndAdd = 'saveAndAdd',
}
